var vertical_embed_viewer_default = {
  "card": "aKOfe",
  "slimLayout": "xM-sR",
  "cardLayout": "x8Qsv",
  "imageContainer": "BcNsf",
  "image": "KR9RP",
  "content": "_52j8L"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
